import { createSpinGesture } from './spinFactory.js';
export default createSpinGesture('right');
